/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const GET_PAYMENT_USED_TO_PLACE_ORDER = 'MFE/CHECKOUT/GET_PAYMENT_USED_TO_PLACE_ORDER';
export const UPDATE_PAYMENT_USED_TO_PLACE_ORDER = 'MFE/CHECKOUT/UPDATE_PAYMENT_USED_TO_PLACE_ORDER';
